import type { DropdownMenuItem } from "ui/components/DropdownMenu";
import { DropdownMenuAndButton } from "ui/components/DropdownMenu";
import cx from "ui/cx";
import styles from "./ImageCard.module.scss";

export interface ImageCardProps {
  imageUrl: string | undefined;
  onChange?: () => void;
  groupName?: string;
  optionName?: string;
  optionValue?: string;
  active?: boolean;
  cardType?: "radio" | "standalone";
  menuItems?: DropdownMenuItem[];
  disabled?: boolean;
}

export default function ImageCard({
  groupName,
  optionName,
  optionValue,
  imageUrl,
  onChange,
  active = false,
  cardType = "standalone",
  menuItems = [],
  disabled = false,
}: ImageCardProps) {
  const id = `${groupName}-${optionName}`;

  return (
    <div
      className={cx({ styles, wrapper: true, active, hover: cardType === "radio" && !disabled, disabled })}
      onClick={disabled ? undefined : onChange}
    >
      {!disabled && cardType === "standalone" && menuItems.length > 0 && (
        <div className="overflow-menu">
          <DropdownMenuAndButton menuItems={menuItems} />
        </div>
      )}
      {imageUrl ? (
        <img
          src={imageUrl}
          className={cardType === "radio" ? "option-card-image option-card-image-radio" : "option-card-image"}
        />
      ) : (
        <div className="option-card-fallback">Upload a logo here.</div>
      )}
      {cardType === "radio" && (
        <div className="option-selection">
          <label className="card-description" htmlFor={id}>
            <input
              id={id}
              key={id}
              type="radio"
              name={groupName}
              value={optionValue}
              checked={active}
              onChange={onChange}
              disabled={disabled}
            />
          </label>
          <span className="image-option-info">{optionName}</span>
        </div>
      )}
    </div>
  );
}
